import { render, staticRenderFns } from "./PalletDetailStats.vue?vue&type=template&id=7b65eb37&scoped=true"
import script from "./PalletDetailStats.vue?vue&type=script&lang=js"
export * from "./PalletDetailStats.vue?vue&type=script&lang=js"
import style0 from "./PalletDetailStats.vue?vue&type=style&index=0&id=7b65eb37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b65eb37",
  null
  
)

export default component.exports